import { Box, Typography } from "@material-ui/core";
import styled from "@emotion/styled";

interface StepProps {
  title: string;
  image: React.ReactNode;
  list: {
    title: string;
    description: string;
  }[];
}

const StepLabel = styled(Box)`
  position: absolute;
  bottom: 6px;
  right: 0;
  background-color: ${(p) => p.theme.palette.primary.main};
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  padding: 4px 10px 4px 18px;
  height: 34px;
  line-height: 1;
  text-transform: uppercase;
  &:before {
    content: "";
    position: absolute;
    right: -11px;
    bottom: 0px;
    background-color: ${(p) => p.theme.palette.primary.main};
    height: 34px;
    width: 32px;
    transform: skewX(-32deg);
    z-index: -1;
  }
`;

const UL = styled.ul`
  list-style: none;
`;

const LI = styled.li`
  position: relative;
  margin-bottom: 20px;
  :before {
    content: "";
    position: absolute;
    left: -20px;
    top: 4px;
    border-radius: 999px;
    height: 12px;
    width: 12px;
    background-color: ${(p) => p.theme.palette.primary.main};
  }
`;

const ListTitle = styled(Typography)`
  font-weight: 700;
  letter-spacing: 0.05em;
`;

export default function Step({ title, image, list }: StepProps) {
  return (
    <>
      <Box width={300} position="relative" zIndex={1}>
        {image}
        <StepLabel>{title}</StepLabel>
      </Box>
      <UL>
        {list.map((listItem) => (
          <LI key={`${listItem.title}-${listItem.description}`}>
            <ListTitle variant="h5">{listItem.title}</ListTitle>
            <Typography variant="body1">{listItem.description}</Typography>
          </LI>
        ))}
      </UL>
    </>
  );
}
